import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  radioGroup: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '-10px',
    
  },
  button: {
    marginTop: '30px',
    borderRadius: '50px',
    width:'500px',
    // marginLeft: '65px',
    color: '#000',
    backgroundColor: 'green'

  },
 
 
}));